import { includes } from 'lodash'

export default {
  namespaced: true,
  state: {
    consent: [],
    consented: false,
    date: null,
    settings: {
      marketing: '',
      message: 'Msg block',
      button: 'Button block'
    }
  },
  mutations: {
    check(state, payload) {
      state.date = Date.now()
      state.consent = payload.consent
      state.consented = payload.consented
    },
    init(state, payload) {
      Object.assign(state.settings, payload)
    }
  },
  actions: {
    check({ commit }, payload) {
      commit('check', payload)
    },
    init({ commit }, payload) {
      commit('init', payload)
    }
  },
  getters: {
    date: state => state.date,
    consented: state => state.consented,
    settings: state => state.settings,
    marketing: state => includes(state.consent, state.settings.marketing)
  }
}
